import { render, staticRenderFns } from "./Usp_Val_Rep_BAN03_AT03_Tipo_Relacion.vue?vue&type=template&id=4598d3d4"
import script from "./Usp_Val_Rep_BAN03_AT03_Tipo_Relacion.vue?vue&type=script&lang=js"
export * from "./Usp_Val_Rep_BAN03_AT03_Tipo_Relacion.vue?vue&type=script&lang=js"
import style0 from "./Usp_Val_Rep_BAN03_AT03_Tipo_Relacion.vue?vue&type=style&index=0&id=4598d3d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports